import { useEffect } from 'react';
import { gql, useMutation } from '@apollo/client';

import {
  SET_ON_CONTINUE,
  SET_LOADING,
  SET_SUCCESS,
} from '../../reducers/actionReducer';
import LoadingSpinner from '../LoadingSpinner';
import ErrorText from '../ErrorText';
import { useAuth } from '../../hooks/useAuth';

const DELETE_ACCOUNT = gql`
  mutation DeleteAccount {
    deleteAccount {
      message
    }
  }
`;

export default function DeleteAccount({ dispatchAction }) {
  const { signout } = useAuth();

  const [deleteAccount, { loading, error, called, data }] =
    useMutation(DELETE_ACCOUNT);

  useEffect(() => {
    if (deleteAccount) {
      dispatchAction({
        type: SET_ON_CONTINUE,
        payload: {
          onContinue: () => deleteAccount(),
        },
      });
    }
  }, [dispatchAction, deleteAccount]);

  useEffect(() => {
    if (loading !== undefined) {
      dispatchAction({
        type: SET_LOADING,
        payload: { loading },
      });
    }
  }, [dispatchAction, loading]);

  useEffect(() => {
    if (called && data && !error) {
      dispatchAction({
        type: SET_SUCCESS,
        payload: {
          message: 'Account deleted successfully.',
        },
      });
      signout();
    }
  }, [called, data, dispatchAction, error, signout]);

  return (
    <div className="flex flex-col justify-center items-center text-center space-y-3 w-full p-2 min-h-[200px]">
      {loading && <LoadingSpinner />}
      {error && <ErrorText message={error.message} />}
      {!loading && !error && (
        <>
          <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <div className="space-y-2">
            <p className="font-semibold text-red-700 text-sm">
              WARNING! This will permanently delete your account
            </p>
            <p className="text-xs text-gray-600">
              This action will delete all past uploaded data and purchases. You can downgrade your plan to "Always Free" to preserve your purchase history. Would you like to continue with permanently deleting your account?
            </p>
          </div>
        </>
      )}
    </div>
  );
}
